export default __webpack_public_path__ + "7be2927a7152493e3175cad8d68ecbb8.png";